import { InputControlType } from '@wix/events-types';
import { EmailValidator } from 'commons-validator-js';
const emailValidator = new EmailValidator();
export const REQUIRED_ERROR = 'formError.requiredError';
export const EMAIL_ERROR = 'formError.emailError';
export const PHONE_ERROR = 'formError.phoneError';
export const DATE_ERROR = 'formError.dateError';
const isValidDate = (dateString) => {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) {
        return false;
    }
    const d = new Date(dateString);
    const dNum = d.getTime();
    if (!dNum && dNum !== 0) {
        return false;
    }
    return d.toISOString().slice(0, 10) === dateString;
};
const isDateEmpty = (value) => !(value && value.replace(/-/g, '').replace('undefined', ''));
export const required = (value = '', mandatoryFieldText) => typeof value === 'string' && value.trim() ? undefined : mandatoryFieldText ?? REQUIRED_ERROR;
export const arrRequired = (value) => (value && value.length ? undefined : REQUIRED_ERROR);
export const email = (value) => !value ? REQUIRED_ERROR : emailValidator.isValid(value) ? undefined : EMAIL_ERROR;
export const phoneRequired = (value) => (!value ? REQUIRED_ERROR : phone(value));
export const phone = (value) => (!value || /^[0-9()+\-\s]{0,25}$/.test(value) ? undefined : PHONE_ERROR);
export const fullAddressRequired = (value) => {
    const errors = [];
    for (let i = 0; i < 5; i++) {
        if (!value || !value[i]) {
            errors[i] = REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
export const shortAddressRequired = (value) => (value && value[0] ? undefined : [REQUIRED_ERROR]);
export const dateRequired = (value) => (isDateEmpty(value) ? REQUIRED_ERROR : date(value));
export const date = (value) => (isDateEmpty(value) || isValidDate(value) ? undefined : DATE_ERROR);
export const guestNamesRequired = (value) => {
    const additionalGuests = value?.additionalGuests ?? 0;
    const guestNames = value?.guestNames ?? [];
    const errors = [];
    for (let i = 0; i < additionalGuests; i++) {
        if (!(guestNames[i] && guestNames[i].firstName)) {
            errors[i] = errors[i] || {};
            errors[i].firstName = REQUIRED_ERROR;
        }
        if (!(guestNames[i] && guestNames[i].lastName)) {
            errors[i] = errors[i] || {};
            errors[i].lastName = REQUIRED_ERROR;
        }
    }
    return errors.length ? errors : undefined;
};
export const FORM_FIELD_VALIDATION = {
    input: (field) => {
        if (field.name.includes('email')) {
            return email;
        }
        else if (field.name.includes('phone')) {
            return field.mandatory ? phoneRequired : phone;
        }
        else {
            return field.mandatory ? required : undefined;
        }
    },
    textarea: (field) => (field.mandatory ? required : undefined),
    dropdown: () => undefined,
    radio: () => undefined,
    checkbox: (field) => (field.mandatory ? arrRequired : undefined),
    address: (field) => (field.mandatory ? (field.full ? fullAddressRequired : shortAddressRequired) : undefined),
    date: (field) => (field.mandatory ? dateRequired : date),
    guestsControl: (field) => (field.requireGuestNames ? guestNamesRequired : undefined),
};
export const NEW_FORM_FIELD_VALIDATION = {
    [InputControlType.INPUT]: (control) => {
        if (control.name.includes('email')) {
            return email;
        }
        else if (control.name.includes('phone')) {
            return control.inputs[0].mandatory ? phoneRequired : phone;
        }
        else {
            return control.inputs[0].mandatory ? required : undefined;
        }
    },
    [InputControlType.TEXTAREA]: (control) => control.inputs[0].mandatory ? required : undefined,
    [InputControlType.DROPDOWN]: () => undefined,
    [InputControlType.RADIO]: () => undefined,
    [InputControlType.CHECKBOX]: (control) => control.inputs[0].mandatory ? arrRequired : undefined,
    [InputControlType.ADDRESS_FULL]: (control) => control.inputs[0].mandatory
        ? control.inputs[0].additionalLabels
            ? fullAddressRequired
            : shortAddressRequired
        : undefined,
    [InputControlType.ADDRESS_SHORT]: (control) => control.inputs[0].mandatory
        ? control.inputs[0].additionalLabels
            ? fullAddressRequired
            : shortAddressRequired
        : undefined,
    [InputControlType.DATE]: (control) => control.inputs[0].mandatory ? dateRequired : date,
    [InputControlType.GUEST_CONTROL]: (control) => control.inputs[1].mandatory ? guestNamesRequired : undefined,
};
export const validate = (values) => ({
    firstName: required(values.firstName),
    lastName: required(values.lastName),
});
//# sourceMappingURL=form-validation.js.map